import * as Sentry from '@sentry/browser';
import { Action, createHook, createStore } from 'react-sweet-state';

import urls from 'src/redux/pull-request/urls';
import authRequest from 'src/utils/fetch';

import { ReviewGroupsState } from './types';

const fetchReviewGroups =
  (
    repositoryOwner: string,
    repositorySlug: string,
    pullRequestId: string
  ): Action<ReviewGroupsState> =>
  async ({ setState }) => {
    const requestUrl = urls.api.internal.reviewGroups(
      repositoryOwner,
      repositorySlug,
      pullRequestId
    );
    setState({ isLoading: true });
    try {
      const response = await fetch(authRequest(requestUrl));
      const body = await response.json();
      if (!response.ok) {
        throw Error(body.error.message);
      }
      setState({
        reviewGroups: body.reviewGroups,
      });
    } catch (e) {
      Sentry.captureException(e);
    } finally {
      setState({ isLoading: false });
    }
  };

const initialState: ReviewGroupsState = {
  isLoading: true,
  reviewGroups: [],
};

const actions = {
  fetchReviewGroups,
};

const ReviewGroupsStore = createStore({
  initialState,
  actions,
});

export const useReviewGroupsActions = createHook(ReviewGroupsStore);
